import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Item\DeleteItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/DeleteItemToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales/{enaos_item}'
*/
const DeleteItemToEnaosController = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteItemToEnaosController.url(args, options),
    method: 'delete',
})

DeleteItemToEnaosController.definition = {
    methods: ["delete"],
    url: '/api/item/{item}/enaos/item-for-sales/{enaos_item}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\Item\DeleteItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/DeleteItemToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales/{enaos_item}'
*/
DeleteItemToEnaosController.url = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            item: args[0],
            enaos_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        item: typeof args.item === 'object'
        ? args.item.id
        : args.item,
        enaos_item: typeof args.enaos_item === 'object'
        ? args.enaos_item.id
        : args.enaos_item,
    }

    return DeleteItemToEnaosController.definition.url
            .replace('{item}', parsedArgs.item.toString())
            .replace('{enaos_item}', parsedArgs.enaos_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Item\DeleteItemToEnaosController::__invoke
* @see app/Http/Controllers/Item/DeleteItemToEnaosController.php
* @route '/api/item/{item}/enaos/item-for-sales/{enaos_item}'
*/
DeleteItemToEnaosController.delete = (args: { item: string | { id: string }, enaos_item: string | number | { id: string | number } } | [item: string | { id: string }, enaos_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteItemToEnaosController.url(args, options),
    method: 'delete',
})

export default DeleteItemToEnaosController